import { FieldProps } from './types'

import React from 'react'

import { emailRex, emailIsNotCorrect, fieldCannotBeEmpty } from 'settings'

import { TextField } from '@mui/material'

export const FieldEmail = ({
  defaultValue = '',
  readOnly = false,
  register,
  label = 'Email',
  formState: { errors },
}: FieldProps) => (
  <TextField
    error={!!errors.email}
    label={label}
    variant="outlined"
    type="email"
    fullWidth
    disableUnderline
    id={'email'}
    defaultValue={defaultValue}
    readOnly={readOnly}
    inputProps={{
      ...register('email', {
        required: fieldCannotBeEmpty,
        pattern: {
          value: emailRex,
          message: emailIsNotCorrect,
        },
      }),
    }}
    helperText={errors?.email?.message}
  />
)
